import { Box } from '@mui/joy';
import { useState, useRef, useEffect } from 'react';
import JSONPretty from 'react-json-pretty';
import { useFormatter, useString } from 'src/mtska-frontend-app-component/utils';
import { useTranslation } from 'react-i18next';

const CommissionDealNode = (props) => {
    const ref = useRef(null);
    const { formatDate } = useFormatter();
    const { t } = useTranslation();
    const [counterparts, setCounterparts] = useState();

    useEffect(() => {
        if (!props.item) return;
        if (props.item.applyTo == 'legalEntity' ) {
            setCounterparts(props.item.partners);
        } else {
            setCounterparts(props.item.employents);
        }
    }, [props.item])

    const { toColor } = useString();

    return (
        <Box ref={ref} className="flow-node flow-node-deal">
            {/* <JSONPretty data={rulesets} className='json-wrapper' /> */}
            {/* <Box className="partner" style={{ backgroundColor: toColor(props.item.partner.name + props.item.partner.name) }}>{props.item.partner.name} {props.item.partner.logo}</Box> */}
            <Box className="title">{props.item.name}</Box>
            <Box className="dates">
                <Box className="start_at">{formatDate(props.item.start_at)}</Box>
                <Box className="end_at">{formatDate(props.item.end_at)}</Box>
            </Box>
            <Box className="priority">{props.item.siblingPriority}</Box>
            
        </Box>
    );
};

export default CommissionDealNode